/**
 * Component Boutiques Marketing Assets
 *
 * Category filter chips for the marketing asset grid on /pages/boutiques.
 *
 * @module component-boutiques-marketing-assets
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-boutiques-marketing-assets';

if (!customElements.get(customElements.component)) {
    const selectors = {
        filter: '[data-asset-filter]',
        card: '[data-asset-card]'
    };

    const classes = {
        activeChip: 'boutiques-marketing-assets__chip--active'
    };

    class componentBoutiquesMarketingAssets extends HTMLElement {

        /**
         * Boutiques marketing assets web component.
         *
         * @constructor
         */
        constructor() {
            super();

            this.filters = this.querySelectorAll(selectors.filter);
            this.cards = this.querySelectorAll(selectors.card);

            this.initEvents();
        }

        /**
         * Init component events.
         *
         * @returns {undefined}
         */
        initEvents() {
            if (!this.filters.length || !this.cards.length) return false;

            this.filters.forEach((filter) => {
                filter.addEventListener('click', () => {
                    this.applyFilter(filter.getAttribute('data-category') || '');
                    this.setActiveChip(filter);
                });
            });
        }

        /**
         * Mark the clicked chip as the active one.
         *
         * @param {HTMLElement} activeFilter The chip that was clicked.
         * @returns {undefined}
         */
        setActiveChip(activeFilter) {
            this.filters.forEach((filter) => {
                const isActive = filter === activeFilter;

                filter.classList.toggle(classes.activeChip, isActive);
                filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
        }

        /**
         * Show only the cards matching a category. An empty category shows all of them.
         *
         * @param {string} category The category to filter by.
         * @returns {undefined}
         */
        applyFilter(category) {
            this.cards.forEach((card) => {
                card.hidden = category !== '' && card.getAttribute('data-category') !== category;
            });
        }
    }

    customElements.define(customElements.component, componentBoutiquesMarketingAssets);
}
